// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Coupon from '../components/Coupon/Coupon';
import {actions as CouponsAction} from '../duck';
import {actions as ManualOrderActions} from '../../../manual-order/duck';
import {actions as CategoryActions} from '../../../categories/duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    coupon: state.coupons.coupon,
    isSaving: state.coupons.isSaving,
    isFetchingCoupon: state.coupons.isFetchingCoupon,
    error: state.coupons.error,
    errorCode: state.coupons.errorCode,
    createCouponSuccess: state.coupons.createCouponSuccess,
    updateCouponSuccess: state.coupons.updateCouponSuccess,
    deleteCouponSuccess: state.coupons.deleteCouponSuccess,
    currency: state.currency.currency,
    productsFilter: state.manualOrder.products,
    paginationProducts: state.manualOrder.pagination,
    categoriesFilter: state.categories.categoriesFilter,
    isFetchingProducts: state.manualOrder.isFetchingProducts,
    isFetchingCategories: state.categories.isFetching,
    paginationCategories: state.categories.paginationFilter,
    coupons: state.coupons.coupons,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {...CouponsAction, ...ManualOrderActions, ...CategoryActions},
      dispatch
    )
)(Coupon);
